import _ from 'lodash';
import moment from 'moment';
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { recordActions } from '../../config/configuration/react';
import { useOffers } from './useOffers';

export const useAutobizTradePage = ({ recordId }) => {
  const dispatch = useDispatch();
  const tradeId = useSelector((state) => state.reduxRecords.data[recordId]?.record?.autobizTradeUuid || null);
  const {
    offersLoading,
    offersErrorApi,
    setLoading: setOffersLoading,
    offers,
    sales,
    supOfferId,
  } = useOffers({
    recordId,
    type: 'stock',
  });
  const trade = useSelector((state) => state.reduxRecords.data[recordId]?.trade || {});
  const endDateTimeTradeRedux = useSelector(
    (state) => state.reduxRecords.data[recordId]?.trade?.sale?.end_date_time || null,
  );
  const coverage = useSelector((state) => state.reduxRecords.data[recordId]?.coverage || {});
  const expertiseCosts = useSelector((state) => state.reduxRecords.data[recordId]?.expertiseCosts?.mdCosts);
  const counterInspection = useSelector((state) => state.reduxRecords.data[recordId]?.counterInspection || {});
  const recordTypeId = useSelector((state) => state.reduxRecords.data[recordId]?.record?.recordTypeId || null);
  const { expired } = coverage;
  let { authorization } = coverage;
  authorization = authorization ? authorization.toLowerCase() : authorization;
  let status = sales?.sale_status?.name ? sales.sale_status.name : null;
  switch (status) {
    case 'winner_to_designate':
      status = 'winnerToDesignate';
      break;
    case 'closed_order_confirmed':
      status = 'stockClosedOrderConfirmed';
      break;
    case 'closed_no_purchase':
      status = 'stockClosedNoPurchase';
      break;
    default:
      break;
  }
  const end_date_time = sales?.end_date_time || endDateTimeTradeRedux;
  const [showManuelSale, setShowManuelSale] = useState(false);
  const [showExpressSale, setShowExpressSale] = useState(false);
  const [showHistoryAt, setShowHistoryAt] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const isMounted = useRef(false);
  const actions = [];
  actions.showManuelSale = showManuelSale;
  actions.setShowManuelSale = setShowManuelSale;
  actions.showExpressSale = showExpressSale;
  actions.setShowExpressSale = setShowExpressSale;
  actions.showHistoryAt = showHistoryAt;
  actions.setShowHistoryAt = setShowHistoryAt;
  let showBlocPending = false;
  if (status && ['draft', 'inactive', 'scheduled'].includes(status.toLowerCase())) {
    showBlocPending = true;
  }

  const showParameters = tradeId !== null && tradeId !== 0;
  const parameters = {
    end_date_time: _.get(sales, 'end_date_time', null),
    start_date_time: _.get(sales, 'start_date_time', null),
    sale_offer_type: _.get(sales, 'sale_offer_type', null),
    salePointOfSaleName: _.get(sales, 'session_vehicle.vehicle.dealer.name', null),
    status,
  };
  let offersTitle = '';
  if (offers?.length > 0) {
    offersTitle = 'received_offers';
  } else {
    offersTitle = ['INACTIVE', 'draft'].includes(status) ? '' : 'upcoming_offers';
  }
  const showManualTitle = tradeId !== null && ['CLOSED', 'INACTIVE', 'draft'].includes(status);

  const postAnnonceAt = async (body) => {
    let { id: owner } = await dispatch(recordActions.fetchGroupUserInfos());
    owner = "/api/users/"+owner;
    dispatch(recordActions.postAnnonceAtTrade({ ...body, owner }));
  };
  const postOffer = async () => {
    if (tradeId !== null) return { id: tradeId };
    return dispatch(recordActions.postOffer(recordId));
  };
  useEffect(() => {
    if (tradeId !== null && sales.id !== undefined && sales.id !== null) {
      const resEndDate = Object.keys(sales).length > 0 ? end_date_time : _.get(sales, 'end_date_time', null);
      if (resEndDate) {
        if (moment().isAfter(resEndDate)) {
          setShowForm(true);
        } else {
          setShowForm(false);
        }
      } else setShowForm(false);
    } else {
      setOffersLoading(false);
      setShowForm(true);
    }
    return () => {
      isMounted.current = true;
    };
  }, [trade]);
  return {
    pdv: sales?.session_vehicle?.vehicle?.dealer?.name,
    offersErrorApi,
    offersLoading,
    status,
    actions,
    showBlocPending,
    postOffer,
    postAnnonceAt,
    showForm,
    offers,
    sales: Object.keys(sales).length > 0 ? sales : parameters,
    showParameters,
    showOffers: offers?.length > 0,
    offersTitle,
    disableCta: !!(authorization === 'y' && !expired),
    showManualTitle,
    supOfferId,
    counterInspection,
    recordTypeId,
    expertiseCosts,
  };
};
